import React from 'react';
import PropTypes from 'prop-types';

import VennImages from 'dpl/components/VennImages';
import { getOrderedParents } from 'dpl/shared/utils/breeder_app';

const litterParentsVennImagesDefaultPropVennImageProps = {};
/** @param {any} props */
export default function LitterParentsVennImages({
  litterParents,
  vennImageProps = litterParentsVennImagesDefaultPropVennImageProps,
  fallbackImage = null
}) {
  const parentImages = getOrderedParents(litterParents).map(parent => ({
    src: parent.profile_photo_url,
    alt: parent.name ?? 'Unnamed'
  }));

  const images =
    parentImages.length === 0 && fallbackImage ? [fallbackImage] : parentImages;

  return <VennImages {...vennImageProps} images={images} />;
}

LitterParentsVennImages.propTypes = {
  litterParents: PropTypes.arrayOf(
    PropTypes.shape({
      profile_photo_url: PropTypes.string,
      name: PropTypes.string,
      gender: PropTypes.string.isRequired
    })
  ).isRequired,
  // Shown in place of the parents when the litter has none, e.g. the breed's
  // cover photo. A null `src` falls through to the dog placeholder.
  fallbackImage: PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string
  }),
  // eslint-disable-next-line react/forbid-prop-types
  vennImageProps: PropTypes.any
};
